"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcScoreForPlayer = exports.advanceState = exports.update = exports.getPlayer = exports.getCurrentPlayer = exports.resetCurrentPlayerGamepadXY = exports.advancePlayer = exports.createPlayersFromPlayersMenu = exports.reset = exports.get = exports.getCrokinolePlayerPosition = exports.CrokinoleShotMode = exports.CrokinoleControlScheme = exports.CrokinoleGameStates = void 0;
var crokinoleUi_menu_players_sidecar_1 = require("@crokinole/ui-menus/crokinoleUi_menu_players-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var crokinolePucks_sidecar_1 = require("../entities/crokinolePucks-sidecar");
var crokinoleDefs_1 = require("./crokinoleDefs");
var crokinoleDefs_sidecar_1 = require("./crokinoleDefs-sidecar");
var crokinoleGamepadCursors_sidecar_1 = require("@crokinole/cursors/crokinoleGamepadCursors-sidecar");
var namespace = 'crokinole_board';
exports.CrokinoleGameStates = {
    gameStart: 0,
    place: 1,
    flick: 2,
    wait: 3,
};
exports.CrokinoleControlScheme = {
    mouse: 0,
    gamepad: 1,
};
exports.CrokinoleShotMode = {
    hitOpponent: 0,
    getInCenter: 1,
};
// Non-teams
// const CrokinolePlayerPositions: ICrokinolePlayerPosition[] = [
//   {
//     quadrantOffsetX: 0,
//     quadrantOffsetY: -1,
//     piecesOffsetX: 0.25,
//     piecesOffsetY: -1,
//     piecesInHoleOffsetX: 0.55,
//     piecesInHoleOffsetY: -0.8,
//     quadrant: 2,
//   },
//   {
//     quadrantOffsetX: 0,
//     quadrantOffsetY: 1,
//     piecesOffsetX: 0.25,
//     piecesOffsetY: 1,
//     piecesInHoleOffsetX: -0.55,
//     piecesInHoleOffsetY: 0.8,
//     quadrant: 0,
//   },
//   {
//     quadrantOffsetX: -1,
//     quadrantOffsetY: 0,
//     piecesOffsetX: -1,
//     piecesOffsetY: 0.25,
//     piecesInHoleOffsetX: -0.8,
//     piecesInHoleOffsetY: 0.55,
//     quadrant: 3,
//   },
//   {
//     quadrantOffsetX: 1,
//     quadrantOffsetY: 0,
//     piecesOffsetX: 1,
//     piecesOffsetY: -0.25,
//     piecesInHoleOffsetX: 0.8,
//     piecesInHoleOffsetY: -0.55,
//     quadrant: 1,
//   },
// ]
// Hack for teams
var CrokinolePlayerPositions = [
    {
        quadrantOffsetX: 0,
        quadrantOffsetY: -1,
        piecesOffsetX: 0.25,
        piecesOffsetY: -1,
        piecesInHoleOffsetX: 0.55,
        piecesInHoleOffsetY: -0.8,
        quadrant: 2,
    },
    {
        quadrantOffsetX: -1,
        quadrantOffsetY: 0,
        piecesOffsetX: -1,
        piecesOffsetY: 0.25,
        piecesInHoleOffsetX: -0.8,
        piecesInHoleOffsetY: 0.55,
        quadrant: 3,
    },
    {
        quadrantOffsetX: 0,
        quadrantOffsetY: 1,
        piecesOffsetX: 0.25,
        piecesOffsetY: 1,
        piecesInHoleOffsetX: -0.55,
        piecesInHoleOffsetY: 0.8,
        quadrant: 0,
    },
    {
        quadrantOffsetX: 1,
        quadrantOffsetY: 0,
        piecesOffsetX: 1,
        piecesOffsetY: -0.25,
        piecesInHoleOffsetX: 0.8,
        piecesInHoleOffsetY: -0.55,
        quadrant: 1,
    },
];
var getCrokinolePlayerPosition = function (player) {
    return CrokinolePlayerPositions[player.playerPosition];
};
exports.getCrokinolePlayerPosition = getCrokinolePlayerPosition;
var _obj = null;
function get() {
    if (!_obj) {
        create();
        exports.reset();
    }
    assert_sidecar_1.assert.notNil(_obj);
    return _obj;
}
exports.get = get;
var create = function () {
    var obj = {
        //numPlayers: 0,
        rule_numDiscsPerPlayer: 6,
        players: [],
        currentPlayerNum: 0,
        currentPuck: null,
        state: exports.CrokinoleGameStates.gameStart,
        // gamepadX: 0,
        // gamepadY: 0,
        allStillTime: 0,
        isAllStill: true,
        shotMode: exports.CrokinoleShotMode.getInCenter,
        // hitOpponent: false,
        lastPuckInHole: false,
    };
    _obj = obj;
};
var reset = function () {
    var obj = get();
    obj.players = [];
    obj.currentPlayerNum = 0;
    obj.currentPuck = null;
    obj.state = exports.CrokinoleGameStates.gameStart;
    crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.reset();
    // obj.gamepadX = 0
    // obj.gamepadY = 0
    obj.allStillTime = 0;
    obj.isAllStill = false;
    // TODO: get these from rules
    obj.rule_numDiscsPerPlayer = crokinoleDefs_sidecar_1.crokinoleDefs.rule_teams ? 6 : 12;
    obj.shotMode = exports.CrokinoleShotMode.getInCenter;
    // obj.hitOpponent = false
    exports.createPlayersFromPlayersMenu();
    exports.resetCurrentPlayerGamepadXY();
};
exports.reset = reset;
var createPlayersFromPlayersMenu = function () {
    var obj = get();
    obj.players = [];
    var humanCount = 0;
    var aiCount = 0;
    var settingsPlayers = crokinoleUi_menu_players_sidecar_1.crokinoleUi_menu_players.get().players;
    console.log('is?', crokinoleUi_menu_players_sidecar_1.crokinoleUi_menu_players.get());
    if (settingsPlayers) {
        for (var i = 0; i < settingsPlayers.length; i++) {
            var sp = settingsPlayers[i];
            if (sp.playerType === 'none') {
                continue;
            }
            if (sp.playerType === 'human') {
                humanCount++;
            }
            if (sp.playerType === 'ai-easy') {
                aiCount++;
                // TODO: add ai players
                continue;
            }
            var currentColor = crokinoleUi_menu_players_sidecar_1.crokinoleUi_menu_players.getPlayerColor(sp);
            var currentSymbol = crokinoleUi_menu_players_sidecar_1.crokinoleUi_menu_players.getPlayerSymbol(sp);
            var controls = crokinoleUi_menu_players_sidecar_1.crokinoleUi_menu_players.getPlayerControlMode(sp);
            var player = {
                playerNum: obj.players.length,
                name: sp.playerType === 'human' ? "Human " + humanCount : "AI " + aiCount,
                pucks: [],
                numTokensLeft: obj.rule_numDiscsPerPlayer,
                numTokensInHole: crokinoleDefs_sidecar_1.crokinoleDefs.debugTokensInHole
                    ? 3 + obj.players.length
                    : 0,
                color: currentColor.tint,
                symbol: currentSymbol.frame,
                symbolScale: currentSymbol.scale || 1,
                symbolNoTint: currentSymbol.noTint || false,
                controlScheme: controls.controlScheme,
                gamepadNum: controls.gamepadNum,
                playerPosition: obj.players.length,
            };
            obj.players.push(player);
        }
    }
    if (obj.players.length === 0) {
        // Default
        obj.players.push({
            playerNum: 0,
            name: 'Green',
            pucks: [],
            numTokensLeft: obj.rule_numDiscsPerPlayer,
            numTokensInHole: crokinoleDefs_sidecar_1.crokinoleDefs.debugTokensInHole
                ? 3 + obj.players.length
                : 0,
            color: diveColors_1.diveColors.green,
            gamepadNum: 1,
            symbol: null,
            symbolScale: 1,
            symbolNoTint: false,
            controlScheme: crokinoleDefs_sidecar_1.crokinoleDefs.debugGamepad
                ? exports.CrokinoleControlScheme.gamepad
                : exports.CrokinoleControlScheme.mouse,
            playerPosition: crokinoleDefs_1.CrokinoleBoardPosition.bottom,
        });
    }
    // obj.players.push({
    //   name: 'Blue',
    //   pucks: [],
    //   numTokensLeft: obj.numTokensPerPlayer,
    //   numTokensInHole: crokinoleDefs.debugTokensInHole
    //     ? 3 + obj.players.length
    //     : 0,
    //   color: diveColors.darkBlue,
    //   gamepadNum: 1,
    //   controlScheme: crokinoleDefs.debugGamepad
    //     ? CrokinoleControlScheme.gamepad
    //     : CrokinoleControlScheme.mouse,
    //   playerPosition: CrokinoleBoardPosition.left,
    // })
    // obj.players.push({
    //   name: 'Orange',
    //   pucks: [],
    //   numTokensLeft: obj.numTokensPerPlayer,
    //   numTokensInHole: crokinoleDefs.debugTokensInHole
    //     ? 3 + obj.players.length
    //     : 0,
    //   color: diveColors.orange,
    //   gamepadNum: 1,
    //   controlScheme: crokinoleDefs.debugGamepad
    //     ? CrokinoleControlScheme.gamepad
    //     : CrokinoleControlScheme.mouse,
    //   playerPosition: CrokinoleBoardPosition.top,
    // })
    // obj.players.push({
    //   name: 'Red',
    //   pucks: [],
    //   numTokensLeft: obj.numTokensPerPlayer,
    //   numTokensInHole: crokinoleDefs.debugTokensInHole
    //     ? 3 + obj.players.length
    //     : 0,
    //   color: diveColors.red,
    //   gamepadNum: 1,
    //   controlScheme: crokinoleDefs.debugGamepad
    //     ? CrokinoleControlScheme.gamepad
    //     : CrokinoleControlScheme.mouse,
    //   playerPosition: CrokinoleBoardPosition.right,
    // })
};
exports.createPlayersFromPlayersMenu = createPlayersFromPlayersMenu;
var advancePlayer = function () {
    var obj = get();
    obj.currentPlayerNum = (obj.currentPlayerNum + 1) % obj.players.length;
    obj.currentPuck = null;
    exports.advanceState();
    obj.state = exports.CrokinoleGameStates.place;
    obj.shotMode = exports.CrokinoleShotMode.getInCenter;
    // obj.hitOpponent = false
    // obj.allStillTime = 0
    // obj.isAllStill = false
    // resetGamepadXY()
};
exports.advancePlayer = advancePlayer;
var resetCurrentPlayerGamepadXY = function () {
    var offset = 2.5;
    var obj = get();
    var cp = exports.getCurrentPlayer();
    var pp = exports.getCrokinolePlayerPosition(cp);
    if (cp.gamepadNum > -1) {
        var gp = crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.getByGamepadNumber(cp.gamepadNum);
        if (gp) {
            crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.moveToXY(gp, pp.quadrantOffsetX * offset, pp.quadrantOffsetY * offset);
        }
    }
    // obj.gamepadX = pp.quadrantOffsetX * offset
    // obj.gamepadY = pp.quadrantOffsetY * offset
};
exports.resetCurrentPlayerGamepadXY = resetCurrentPlayerGamepadXY;
var getCurrentPlayer = function () {
    var obj = get();
    return exports.getPlayer(obj.currentPlayerNum);
};
exports.getCurrentPlayer = getCurrentPlayer;
var getPlayer = function (playerNum) {
    var obj = get();
    return obj.players[playerNum];
};
exports.getPlayer = getPlayer;
var update = function () { };
exports.update = update;
var advanceState = function () {
    var obj = get();
    obj.allStillTime = 0;
    obj.isAllStill = false;
    if (obj.state === exports.CrokinoleGameStates.gameStart) {
        exports.resetCurrentPlayerGamepadXY();
        obj.state = exports.CrokinoleGameStates.place;
    }
    else if (obj.state === exports.CrokinoleGameStates.place) {
        // resetCurrentPlayerGamepadXY()
        obj.state = exports.CrokinoleGameStates.flick;
    }
    else if (obj.state === exports.CrokinoleGameStates.flick) {
        obj.state = exports.CrokinoleGameStates.wait;
    }
    else if (obj.state === exports.CrokinoleGameStates.wait) {
        obj.state = exports.CrokinoleGameStates.place;
    }
};
exports.advanceState = advanceState;
var calcScoreForPlayer = function (player) {
    //let playerScore = 0
    var inHoleScore = 0; // player.numTokensInHole * 20
    var onBoardScore = 0;
    var numInHole = 0;
    var obj = get();
    obj.players.forEach(function (p) {
        if (p.color !== player.color) {
            return;
        }
        inHoleScore += p.numTokensInHole * 20;
        numInHole += p.numTokensInHole;
    });
    crokinolePucks_sidecar_1.crokinolePucks.getAll().forEach(function (puck) {
        if (puck.player.color === player.color) {
            // if (puck.player === player) {
            onBoardScore += crokinolePucks_sidecar_1.crokinolePucks.calcScoreForPuck(puck);
        }
    });
    var total = inHoleScore + onBoardScore;
    return {
        numTeamInHole: numInHole,
        numThisPlayerInHole: player.numTokensInHole,
        onBoard: onBoardScore,
        //inHole:  // player.numTokensInHole,
        total: total,
    };
};
exports.calcScoreForPlayer = calcScoreForPlayer;
